import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.common.white,
    backgroundColor: '#5F29CC',

    '& h6': {
      marginBottom: theme.spacing(4),
      textAlign: 'center',
      fontWeight: theme.typography.fontWeightBold,
    },
  },
  image: {
    display: 'block',
    margin: '0 auto',
    width: 600,

    [theme.breakpoints.down('md')]: {
      width: 300,
    },
  },
  stepper: {
    backgroundColor: 'transparent',

    [theme.breakpoints.down('lg')]: {
      maxWidth: 500,
      margin: '0 auto',
    },
  },
  stepLabel: {
    color: `${theme.palette.common.white} !important`,
    fontSize: theme.typography.body1.fontSize,
  },
  stepIcon: {
    display: 'inline-block',
    width: 25,
    height: 25,
    color: '#5F29CC',
    backgroundColor: theme.palette.common.white,
    borderRadius: '50%',
    lineHeight: '1.5em',
    textAlign: 'center',
    fontWeight: theme.typography.fontWeightBold,
  },
  subTitle: {
    fontSize: 20,
    fontWeight: '600',
    textAlign: 'center',
    marginBottom: 32,
  },
}));
